import { memo, useEffect, useState } from "react";
import CreateCommentButton from "./components/CreateCommentButton";
import { documentId } from "firebase/firestore";

type Props = {
  documentId: string;
  selectedNodeId: string | null;
  selectedNodeRef: HTMLElement | null;
};

function HoveringToolbar({
  selectedNodeId,
  selectedNodeRef,
  documentId,
}: Props) {
  const [position, setPosition] = useState({ top: 0, opacity: 0 });

  useEffect(() => {
    if (!selectedNodeRef) {
      setPosition((prev) => ({ ...prev, opacity: 0 }));
      return;
    }

    const updatePosition = () => {
      const rect = selectedNodeRef.getBoundingClientRect();

      // Find the closest parent with relative positioning (e.g., .editor-container)
      const parentContainer = selectedNodeRef.closest(".editor-container");
      if (!parentContainer) return;

      const parentRect = parentContainer.getBoundingClientRect();

      setPosition({
        top: rect.top - parentRect.top + parentContainer.scrollTop + 230, // Align with the node inside parent
        opacity: 1,
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition);
    };
  }, [selectedNodeRef]);

  return (
    <div
      className="absolute z-10 h-auto p-2 transition-opacity duration-200 w-60"
      style={{
        top: `${position.top}px`,
        opacity: position.opacity,
        position: "absolute",
      }}
    >
      {/* Add some content here */}
      {selectedNodeId && (
        <CreateCommentButton
          documentId={documentId}
          anchorNodeId={selectedNodeId}
        />
      )}
    </div>
  );
}

export default memo(HoveringToolbar);
